import { HTMLAttributes } from 'react';

import { ChevronRightIcon } from '@components/common/Icons';
import cx from 'classnames';
import { Article } from 'models/stack9/Article';
import moment from 'moment';

import Button from '../Button/Button';

export interface ArticleProps extends HTMLAttributes<HTMLDivElement> {
  article: Article;
}
const ArticleThumbnail = ({ article, className, ...props }: ArticleProps) => {
  return (
    <div
      {...props}
      className={cx(
        className,
        'flex flex-col items-start border-b-4 border-b-blue-100 pb-3',
      )}
    >
      <div className="min-h-[300px] relative mb-3 w-full">
        <img
          className="duration-500 hover:scale-110 object-cover h-[300px] w-[420px]"
          alt={article.heading}
          src={article.image.url}
        />
      </div>
      <h3 className="mb-3 font-light text-dark-blue-100 hover:underline">
        {article.heading}
      </h3>
      <small className="block mb-3 font-medium">
        {moment(article.published_at).format('DD MMMM, YYYY')}
      </small>
      <p className="flex-grow">{article.excerpt}</p>
      <Button color="link" className="px-0 mt-4 font-bold text-coral-100">
        <span>READ MORE</span>
        <ChevronRightIcon />
      </Button>
    </div>
  );
};

export default ArticleThumbnail;
